import React from 'react';

import { openReactActionDialog } from '~src/commonInfra/dialogs/ReactActionDialog';
import { ReactActionDialogOptionsForConfirmationDialog, ReactConfirmationDialogBodyProps, ReactConfirmationDialogOptions } from '~src/commonInfra/dialogs/ReactConfirmationDialog';
import { ModalInstance } from '~src/commonInfra/dialogs/ReactModalService';

export const DeleteGroupSetConfirmationDialogBodyTestId = 'delete-group-confirmation-dialog-body';

export function openDeleteGroupSetConfirmationDialog<ActionParams, TResult>(
    options: ReactConfirmationDialogOptions<ActionParams, TResult>): ModalInstance<TResult> {

    function DeleteGroupSetConfirmationDialogWarningBody(props: ReactConfirmationDialogBodyProps): JSX.Element {
      return (
        <div data-tb-test-id={DeleteGroupSetConfirmationDialogBodyTestId}>
          <div style={{whiteSpace: 'pre-wrap'}}>
            {props.message}
          </div>
        </div>
      );
    }

    const actionDialogOptions: ReactActionDialogOptionsForConfirmationDialog<ActionParams, TResult> = {
      title: options.title,
      bodyComponent: DeleteGroupSetConfirmationDialogWarningBody,
      initialBodyProps: { message: options.message },
      initialDialogState: options.paramsForAction,
      actionName: options.actionName,
      action: (__, params) => options.action(params),
      dialogWidth: options.dialogWidth,
      dismissDialogOnActionFailed: true,
      isActionDelete: options.isActionDelete,
      centerActionButtons: options.centerActionButtons
    };

    return openReactActionDialog(actionDialogOptions);
}
